/* eslint-disable indent */
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
    toRef,
} from '@vue/composition-api';
import { ConfFormOptionsFactory } from '@/components/form/types';
import { Button, Checkbox } from '@ks/ks-element-ui';
import { emitChange } from './utils/emit';
import { Radio } from '@/components/from-item/radio';
import ConfForm from '@/components/form/form';
import Input from '../input/pure-text.vue';

export type ConfFormRef = InstanceType<typeof ConfForm>;

const opt: ConfFormOptionsFactory = () => [
    {
        field: 'type',
        label: '类型',
        col: 24,
        render: (props, { emit }) => (
            <Radio
                list={['邮箱', '手机号']}
                value={props.value}
                onChange={emitChange(emit)}
            ></Radio>
        ),
    },
    {
        field: 'email',
        get label(): string {
            return this.value.type;
        },
        render: (props, { emit }) => (
            <Input value={props.value} onOpdate={emitChange(emit)} />
        ),
        requiredRules: [
            {
                required: true,
                message: '不能为空',
            },
        ],
        rules: [
            {
                asyncValidator(_, value, cb) {
                    if (/@.*\.*/.test(value)) {
                        return cb();
                    }
                    return cb('邮箱格式不对');
                },
            },
        ],
    },
    {
        field: 'code',
        label: <span>验证码</span>,
        get show(): boolean {
            return this.value.type === '手机号';
        },
        // col: 12,
        required: false,
        render: (props, { emit }) => (
            <Input value={props.value} onInput={emitChange(emit)} />
        ),
        requiredRules: [
            {
                required: true,
                message: '不能为空',
            },
        ],
        rules: [
            {
                type: 'string',
                min: 4,
                message: '最少4位',
            },
        ],
    },
    {
        field: 'agree',
        col: 24,
        labelWidth: '60px',
        render: (props, { emit }) => (
            <Checkbox value={props.value} onChange={emitChange(emit)}>
                我同意并遵守上述的《快手开放平台开发者服务协议》
            </Checkbox>
        ),
        requiredRules: [
            {
                type: 'enum',
                enum: [true],
                message: ' ',
            },
        ],
    },
    {
        col: 24,
        render: (props, { emit }) => (
            <div>
                <div style="width: 200px; display: inline-block;"></div>
                <Button type="button" onClick={props.form.reset}>
                    重置
                </Button>
                <Button
                    type="button"
                    disabled={!props.form.canSubmit}
                    onClick={props.form.submit}
                >
                    提交
                </Button>
            </div>
        ),
    },
];

export const FormDemo = defineComponent({
    setup: () => {
        const confForm = ref<ConfFormRef>();
        const a = reactive({ v: 1 });
        const b = toRef(a, 'v');
        onMounted(() => {
            b.value = 2;
            // set(a, 'b', b.value);
            // a.b = b.value;
            // a.b = 2;
            // const ss = reactive({
            //     confForm,
            //     b,
            // });
            // ss.b = 2;
            console.log(a.v);
            // console.log(confForm.value?.reset());
            // if (confForm.value) {
            //     watch(confForm.value.value, () => {
            //         console.log(JSON.stringify(confForm.value.error))
            //     });
            // }
        });

        return {
            confForm,
            b,
        };
    },
    render() {
        // const confForm = this.$refs.confForm;
        return (
            <ConfForm
                style="width: 836px; margin: auto;text-align: left"
                ref="confForm"
                onSubmit={(e) => {
                    console.log('submit', e);
                }}
                initialValue={() => ({
                    email: 'example@email.com',
                    type: '手机号',
                    agree: false,
                    code: '',
                })}
                // labelPosition="top"
                colCount={3}
                options={opt()}
            ></ConfForm>
        );
    },
});

export default ConfForm;
